import { render } from "./formularioVerificacionTarjeta.vue?vue&type=template&id=a05b0d20"
import script from "./formularioVerificacionTarjeta.vue?vue&type=script&lang=js"
export * from "./formularioVerificacionTarjeta.vue?vue&type=script&lang=js"

import "./formularioVerificacionTarjeta.vue?vue&type=style&index=0&id=a05b0d20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__